import { render, staticRenderFns } from "./FilterMenuItem.vue?vue&type=template&id=35173e86&scoped=true&"
import script from "./FilterMenuItem.vue?vue&type=script&lang=js&"
export * from "./FilterMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./FilterMenuItem.vue?vue&type=style&index=0&id=35173e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35173e86",
  null
  
)

export default component.exports